<div class="login-wrapper d-flex align-items-center justify-content-center">
  <div class="auth-img">
    <img src="assets/images/login.png" alt="" class="he" />
  </div>
  <div class="auth-login">
    <div class="text-center my-3">
      <a class="logo" routerLink="/">
        <img src="assets/images/logo.svg" alt="" />
      </a>
    </div>
    <div class="log-title">
      <h1>Welcome back!</h1>
      <mat-button-toggle-group
        (ngModelChange)="onLoginTabChange($event)"
        [(ngModel)]="loginTab"
        class="mb-2"
      >
        <mat-button-toggle value="coach">AS COACH</mat-button-toggle>
        <mat-button-toggle value="school">AS SCHOOL</mat-button-toggle>
        <mat-button-toggle value="athletic-director">AS Athletic Director</mat-button-toggle>

      </mat-button-toggle-group>

      <ng-container *ngIf="!['school'].includes(loginTab)">
        <p>“Coaches”, our TUTORIALS are available on the Dashboard for your convenience.  Please review.</p>
      </ng-container>
      <ng-template>
        <p>
          
        </p>
      </ng-template>
    </div>

    <form [formGroup]="loginForm">
      <div class="auth-form">
        <div class="f-group">
          <input
            type="text"
            class="form-control"
            placeholder="Enter your Email address"
            formControlName="email"
            [class.is-invalid]="!Global.isInputValid(loginForm, 'email')"
          />

          <div
            class="invalid-feedback"
            *ngIf="!Global.isInputRuleValid(loginForm, 'email', 'required')"
          >
            <div>This field is required</div>
          </div>
        </div>

        <div class="f-group">
          <input
            type="password"
            class="form-control"
            placeholder="Enter Password"
            formControlName="password"
            [class.is-invalid]="!Global.isInputValid(loginForm, 'password')"
          />

          <div
            class="invalid-feedback"
            *ngIf="!Global.isInputRuleValid(loginForm, 'password', 'required')"
          >
            <div>This field is required</div>
          </div>

          <div
            class="invalid-feedback"
            *ngIf="!Global.isInputRuleValid(loginForm, 'password', 'minlength')"
          >
            <div>The password should be minimum 8 characters</div>
          </div>

          <div
            class="invalid-feedback"
            *ngIf="!Global.isInputRuleValid(loginForm, 'password', 'maxlength')"
          >
            <div>The password should be maximum 20 characters</div>
          </div>
        </div>

        <div class="f-group d-flex align-items-center">
          <div class="">
            <mat-checkbox class="example-margin" formControlName="rememberme"
              >Remember me</mat-checkbox
            >
          </div>
          <span class="ms-auto f-pass"
            ><a
              routerLink="/forgot-password"
              [queryParams]="{ tab: queryParams }"
              >Forgot Password?</a
            ></span
          >
        </div>

        <div class="f-group">
          <button mat-button type="submit" (click)="submitLogin($event)">
            <span class="indicator-label">Log in</span>
            <span class="indicator-progress"
              >Please wait...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </button>
        </div>

        <div class="f-group text-center">
          <p>
            Don't have an account yet?
            <a routerLink="/signup" [queryParams]="{ tab: queryParams }"
              >Sign Up</a
            >
          </p>
        <div class="login-footer d-flex align-items-center">
            <p>
                <a target="_blank" routerLink="/privacy-and-policy">Privacy Policy</a>
                <a target="_blank" routerLink="/terms-and-condition">Terms & Conditions</a>
            </p>
            <p class="ms-auto"><a routerLink="/"> {{Global.APP_NAME}}</a> {{Global.CURRENT_YEAR}} | All Rights Reserved</p>
        </div>
      </div>
  </div>
